module.exports = __webpack_public_path__ + "img/background.d86f3c7c.jpg";